export default __webpack_public_path__ + "static/media/python.4298525c.svg";